import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomMessageComponent } from './custom-message.component';



@NgModule({
  declarations: [CustomMessageComponent],
  imports: [
    CommonModule
  ],
  exports:[
    CustomMessageComponent
  ]
})
export class CustomMessageModule { }
